export const isSuccess = (response: any) => {
  if ('error' in response) {
    return false;
  }
  return true;
};
